import React from 'react';
import { Redirect } from 'react-router';

const RedirectToRecord = () => (
    <Redirect to='/record' />
);

export default RedirectToRecord;


// WEBPACK FOOTER //
// ./src/components/RedirectToRecord.js